import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Repeat03 = function Repeat03(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "m13 22-3-3m0 0 3-3m-3 3h5c3.866 0 7-3.134 7-7 0-2.7924-1.6351-5.2029-4-6.3264M6 18.3264C3.635 17.2029 2 14.7924 2 12c0-3.866 3.134-7 7-7h5m0 0-3-3m3 3-3 3"
    })
  }));
};
export default Repeat03;